import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const SimilarProjects = ({ projectImages, projectVideos }) => {
  const [carouselKey, setCarouselKey] = useState(0);

  useEffect(() => {
    // Update the key whenever projectImages or projectVideos change
    setCarouselKey((prevKey) => prevKey + 1);
  }, [projectImages, projectVideos]);

  const options = {
    loop: true,
    autoplay: false,
    center: false,
    items: 3,
    margin: 40,
    nav: true,
    dots: true,
    navText: [
      '<i class="fa fa-angle-left"></i>',
      '<i class="fa fa-angle-right"></i>',
    ],
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 1,
      },
      1024: {
        items: 1,
      },
    },
  };

  return (
    <div className="section-full p-tb80 inner-page-padding">
      <div className="container">
        <div className="section-content">
          <div className="work-carousel-outer">
            <OwlCarousel
              key={carouselKey}
              className="owl-carousel mfp-gallery project-carousel project-carousel1 owl-btn-vertical-center"
              {...options}
            >
              {projectImages.map((item, index) => (
                <div key={index} className="item">
                  <div
                    className="sx-box image-single-carousel bg-contain"
                    style={{ backgroundImage: "url(" + item + ")" }}
                  ></div>
                </div>
              ))}
              {/* {projectVideos.map((video, index) => (
                <div key={index} className="item">
                  <div className="sx-box video-single-carousel">
                    <video controls width="100%">
                      <source src={video.src} type={video.type} />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                </div>
              ))} */}
            </OwlCarousel>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimilarProjects;
